(function($) {

    // Grab video source from data-src
    var $videoSrc;

    $('.js-video-toggle').click(function() {
        $videoSrc = $(this).data( "src" );
    });

    // Autoplay once modal opens
    $('.video-modal').on('shown.bs.modal', function (e) {

        // Sets src to autoplay
        $(this).find(".embed-responsive").html('<iframe src="'+$videoSrc+'" class="embed-responsive-item video" id="video" allowscriptaccess="always" allow="autoplay"></iframe>'); 
    });

    // Stop video on moadal close
    $('.video-modal').on('hide.bs.modal', function (e) {
        $(this).find(".video").attr('src','');
    });


    // Background video pause button
    $('.video-pause-button').on('click', function() {
        const video = $(this).parent('.video-container').find('video');
        if($(this).hasClass('is-paused')) {
            $(this).removeClass('is-paused');
            video[0].play();
            $(this).find('span').text('Pause');
        } else {
            $(this).addClass('is-paused');
            video[0].pause();
            $(this).find('span').text('Play');
        }
    });

}(jQuery));